<template>
  <div>
    <div class="card" v-if="isCard">
      <header class="header-card">
        <p>{{ $t('catalogue.marques') }}</p>
      </header>
      <div class="card-content">
        <p class="mgb-20px has-text-default">
          <span class="has-text-weight-bold">Enseigne principale : </span>
          <span class="is-size-6">{{enseignePrincipaleLibelle}}</span>
        </p>
        <ul class="columns is-12 is-multiline is-fullheight">
          <li
            v-for="(element, index) in entiteCommerciale.enseignesMarques"
            :key="index"
            class="column is-3-fullhd is-4-tablet"
          >
            <div class="enseigne columns is-marginless is-full">
              <div class="column is-narrow  is-paddingless"
                v-if="element.urlLogoMarque ? element.urlLogoMarque : element.urlLogo">
                <img
                  :src="element.urlLogoMarque ? element.urlLogoMarque : element.urlLogo"
                  class="image is-96x96"
                />
              </div>
              <div class="column is-narrow is-paddingless"  v-else>
                <img src="/static/img/gabed/emplacement/image_defaut.png" class="image is-96x96" />
              </div>
              <div class="columns column is-vcentered is-marginless
                is-paddingless is-multiline ellipsis">
                <span class=" column is-12 has-text-weight-bold">
                    {{element.nom ? element.nom : element.marque}}
                </span>
                <span class="is-size-7 column is-12 pdt-0">
                  {{element.libelleTypeMarque ? element.libelleTypeMarque : element.type}}
                </span>
              </div>
              <div class="column is-narrow" v-if="element.idExterne">
                <span class="pastille-verte">
                </span>
              </div>
              <div class="column is-narrow pdt-20px mgt-5px">
                <b-dropdown position="is-bottom-left" aria-role="list"
                  class="is-pulled-right is-relative">
                  <a slot="trigger">
                    <b-icon icon="dots-vertical" class="has-text-secondary-icon"></b-icon>
                  </a>
                  <b-dropdown-item @click="inProgress()">
                    <p class="is-default is-size-6">
                      {{ $t('general.button.edit')}}
                    </p>
                  </b-dropdown-item>
                  <b-dropdown-item @click="inProgress()">
                    <p class="is-default is-size-6">
                      {{ $t('general.button.delete')}}
                    </p>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-else>
      <p class="mgb-20px has-text-default">
        <span class="has-text-weight-bold">Enseigne principale : </span>
        <span class="is-size-6">{{enseignePrincipaleLibelle}}</span>
      </p>
      <ul class="columns is-12 is-multiline is-fullheight">
        <li
          v-for="(element, index) in entiteCommerciale.enseignesMarques"
          :key="index"
           class="column is-4-fullhd is-6-tablet"
        >
          <div class="enseigne columns is-marginless is-full">
            <div class="column is-narrow  is-paddingless"
              v-if="element.urlLogoMarque ? element.urlLogoMarque : element.urlLogo">
              <img
                :src="element.urlLogoMarque ? element.urlLogoMarque : element.urlLogo"
                class="image is-96x96"
              />
            </div>
            <div class="column is-narrow  is-paddingless"  v-else>
              <img src="/static/img/gabed/emplacement/image_defaut.png" class="image is-96x96" />
            </div>
            <div class="columns column is-vcentered is-marginless
                is-paddingless is-multiline ellipsis">
                <p class="column is-12  has-text-weight-bold">
                    {{element.nom ? element.nom : element.marque}}
                </p>
                <span class="is-size-7 column is-12 pdt-0">
                  {{element.libelleTypeMarque ? element.libelleTypeMarque : element.type}}
                </span>
            </div>
            <div class="column is-narrow" v-if="element.idExterne">
              <span class="pastille-verte">
              </span>
            </div>
            <div class="column is-narrow pdt-20px mgt-5px">
              <b-dropdown position="is-bottom-left" aria-role="list"
                class="is-pulled-right is-relative">
                <a slot="trigger">
                  <b-icon icon="dots-vertical" class="has-text-secondary-icon"></b-icon>
                </a>
                <b-dropdown-item @click="inProgress()">
                  <p class="is-default is-size-6">
                    {{ $t('general.button.edit')}}
                  </p>
                </b-dropdown-item>
                <b-dropdown-item @click="inProgress()">
                  <p class="is-default is-size-6">
                    {{ $t('general.button.delete')}}
                  </p>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import inProgress from '@/services/general/inProgress';

export default {
  name: 'CreationEnseignes',
  props: {
    entiteCommerciale: {
      type: Object,
      required: true,
    },
    isCard: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    enseignePrincipaleLibelle() {
      const enseignePrincipale = this.entiteCommerciale.enseignesMarques.find(
        enseigne => {
          return enseigne.enseignePrincipale;
        },
      );
      if (!enseignePrincipale) return '';
      return enseignePrincipale.marque;
    },
  },
  methods: {
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
  },
};
</script>
